import axios from 'axios';
import { logout as superAdminLogout } from '../redux/slices/superAdminSlice';
import { logout as adminLogout } from '../redux/slices/adminSlice';
import { dispatchAction } from '../redux/storeUtils';
import { logout } from '../redux/slices/employeeSlice';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const baseURL = isLocalhost
  ? 'http://localhost:8005/api'
  : 'https://calllogapis.stellarflux.com/api';

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Check for admin token first if the URL contains '/admin'
    if (config.url.includes('/admin') && !config.url.includes('/login')) {
      const adminToken = localStorage.getItem('token');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
        return config;
      }
    }
    
    // Otherwise, use superAdmin token
    const superAdminToken = localStorage.getItem('token');
    if (superAdminToken && !config.url.includes('/login')) {
      config.headers.Authorization = `Bearer ${superAdminToken}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config.url.includes('/login')) {
      // Determine which type of token is being used based on URL or stored tokens
      if (error.config.url.includes('/admin') || localStorage.getItem('token')) {
        dispatchAction(adminLogout());
        window.location.href = '/admin-login';
      }else if(error.config.url.includes('/employee') || localStorage.getItem('token')) {
        dispatchAction(logout());
         window.location.href = '/employee-login';
      }
      else {
        dispatchAction(superAdminLogout());
        window.location.href = '/super-admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;